var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center justify-center w-8 h-10 transition-opacity cursor-pointer hover:opacity-50",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }